module.exports = __webpack_public_path__ + "img/Elements_Icons_Cost Analysts.d3d1f241.png";